import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

// Environment
import { environment } from "src/environments/environment";

// Models
import { Account } from "src/app/accounts-v2/models/account.model";
import { AccountType } from "src/app/accounts-v2/models/fields/accountType.model";
import { AccountWithName } from "src/app/accounts-v2/models/accountWithName";
import { Stage } from "src/app/accounts-v2/models/configuration/stage.model";
import { SavedFilterData } from "../models/filter.model";

@Injectable()

export class AccountsHttpService {
    private baseUrl: string = environment.apiUrlAccount + "Account/";
    private contactUrl: string = environment.contactURL;
    private baseConfigURL: string =  environment.configUrlV2;

    constructor(private http: HttpClient) { }

    getAllAccounts(data): Promise<AccountWithName[]> {
        let url: string = this.baseUrl + 'AccountsWithName';

        if (data && data['search']) {
            url = url + '?search=' + encodeURIComponent(data['search']);
        }

        if (data && data['search'] && data['channelId']) {
            url = url + `&channelId=${data['channelId']}`;
        }

        if (data && !data['search'] && data['channelId']) {
            url = url + `?channelId=${data['channelId']}`;
        }

        return this.http.get<AccountWithName[]>(url).toPromise().then(res => res);
    }

    getAllAccountsBySearch(pageSize: number, pageNumber: number, organizationId: number, loginUserId: number, parentId: number = 0,
        dateSearch: string, columns: any[], channelId: number, stageId?: number, searchValue?: string, searchFields?: string,
        options?: any): Promise<any> {
        stageId = stageId || 0;

        // Preparing
        let url: string = this.baseUrl + "?organizationId=" + organizationId + "&loginUserId=" + loginUserId + "&typeId=" + channelId +
            "&stageId=" + stageId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&filter=" + dateSearch + "&isActive=" +
            options.isActive;

        // Check appending account contacts to url
        const checkContactColumn = columns.find(el => el.field == "contactName");

        if (checkContactColumn?.show) {
            url += '&objectNameList=accountcontacts';
        }

        // Check appending account phones to url
        const checkPhonesColumn = columns.find(el => el.field == "phone");

        if (checkPhonesColumn?.show) {
            url += '&objectNameList=accountphones';
        }

        // Check appending account types to url
        const checkAccountTypesColumn = columns.find(el => el.field == "accountTypesNames");

        if (checkAccountTypesColumn?.show) {
            url += '&objectNameList=accountTypes';
        }

        url += "&objectNameList=status&objectNameList=childaccounts&parentAccountId=" + parentId;

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            } else if (options.moduleSearchValue) {
                url = `${url}&moduleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
            }
        }

        if (dateSearch != 'recentlyviewedcontacts' && (!options || !options.sort)) {
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        if (searchValue) {
            url = `${url}&SearchValue=${encodeURIComponent(searchValue)}`;
        }

        if (searchFields) {
            url = `${url}&SearchColumns=${searchFields}`;
        }

        return this.http.get<Promise<{ accounts: Account[]; headers: HttpHeaders }>>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                accounts: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    getAccountDetails(accountId: number,includeDeleted: boolean = false): Observable<Account> {
        let params = new HttpParams();
        if(includeDeleted){
            params = params.append('includeDeleted', true);
        }
        params = params.append('excludeTerritory', true);
        return this.http.get<Account>(`${environment.apiUrlAccount}v2/Account/${accountId}/Details`,{params});
    }

    getAllAccountsCount(organizationId: string, groupId: number, typeId: number, filter: string, isActive: boolean): Observable<Stage[]> {
        return this.http.get<Stage[]>(this.baseUrl + 'Count?organizationId=' + organizationId + '&groupId=' + groupId + "&typeId=" +
            typeId + "&filter=" + filter + '&isActive=' + isActive);
    }

    addAccount(accountData: any): Observable<any> {
        return this.http.post<any>(this.baseUrl, accountData);
    }

    updateAccount(accountData: any): Observable<any> {
        return this.http.put<any>(this.baseUrl, accountData);
    }

    getAllAccountContacts(accountId: number): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}Contact?accountId=${accountId}`);
    }

    addContact(contactData): Observable<any> {
        return this.http.post<any>(this.contactUrl + 'Contact', contactData);
    }

    // Dropdown Values API List
    getAllAccountTypes(): Observable<AccountType[]> {
        return this.http.get<AccountType[]>(`${environment.apiUrlAccount}Type/AccountTypeMinified`);
    }

    getAllStages(moduleId: number,channelId: number, subTerritoryId: number = 0): Observable<any[]> {

        let params = new HttpParams();

        if(subTerritoryId>0)
        params = params.append("subTerritoryId", `${subTerritoryId}`)

        return this.http.get<AccountType[]>(`${this.baseConfigURL}/Stage/Module/${moduleId}/Channel/${channelId}`, { params });
    }

    getAccountList(value:any) {
        return this.http.get<any>(`${environment.apiUrlAccount + "Account/"}AccountsWithName?search=${value}`);
    }
    // Account/AddAccountAddress
    addAccountAddress(data): Observable<any>{
        return this.http.post<any>(`${this.baseUrl}AddAccountAddress`,data);
    }

    editAccountAddress(data): Observable<any>{
        return this.http.put<any>(`${this.baseUrl}UpdateAccountAddress`,data);
    }

    deleteAccountAddress(id): Observable<any>{
        return this.http.delete<any>(`${this.baseUrl}DeleteAccountAddress/${id}`);
    }

    getAccountAddress(id): Observable<any>{
        return this.http.get<any>(`${this.baseUrl}GetAccountAddress/${id}`);
    }

}
